export default __webpack_public_path__ + "static/media/brand.6ae40e94.png";